import { render } from "./Policies.vue?vue&type=template&id=4a99d968&ts=true"
import script from "./Policies.vue?vue&type=script&lang=ts"
export * from "./Policies.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__